import styled from 'styled-components';

export const TooltipStyle = styled.div`
.MuiButton-root {
  text-transform: lowercase;
}
`;
